/**
 * Modelo de um critério de filtro individual
 */
export interface PgcFilterCriteria {
  field: string;        // Nome do campo (ex: c1_quje)
  fieldLabel: string;   // Descrição do campo (ex: Qtd. Já Entregue)
  operator: string;     // Operador (eq, ne, gt, ge, lt, le)
  operatorLabel: string;// Descrição do operador (ex: Igual a)
  value: string;        // Valor da expressão
}

/**
 * Modelo de um filtro salvo (conjunto de critérios nomeado)
 */
export interface PgcSavedFilter {
  name: string;                     // Nome do filtro (ex: "Padrão", "Itens pendentes")
  criteria: PgcFilterCriteria[];    // Lista de critérios do filtro
  isDefault?: boolean;              // Indica se é o filtro aplicado automaticamente
}

/**
 * Modelo de um campo disponível para filtro (proveniente da estrutura da tabela)
 */
export interface PgcFilterField {
  field: string;    // Nome do campo (ex: C1_QUJE)
  title: string;    // Título/descrição do campo
  type: string;     // Tipo do campo (C=Caracter, N=Numérico, D=Data, L=Lógico)
  size: number;     // Tamanho do campo
  decimal: number;  // Casas decimais (para numérico)
}

/**
 * Operadores disponíveis para filtro
 */
export const PGC_FILTER_OPERATORS = [
  { value: 'eq', label: 'Igual a' },
  { value: 'ne', label: 'Diferente de' },
  { value: 'gt', label: 'Maior que' },
  { value: 'ge', label: 'Maior ou igual a' },
  { value: 'lt', label: 'Menor que' },
  { value: 'le', label: 'Menor ou igual a' }
];
